<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import PersonNameConverter from "../../Services/PersonNameConverter";
import ScholarshipMeetingVoteApi from "../../Services/Api/MeetingApi/ScholarshipMeetingVoteApi";
import _ from "lodash";

export default {
  name: "TheMeetingVotingTable",

  data() {
    return {
      headers: [
        {
          text: 'Место',
          value: 'Number',
          groupable: false,
          sortable: false,
          width: '6%',
          align: "center",
          cellClass: "text-body-1",
        },
        {
          text: 'Участник',
          value: 'participant',
          groupable: false,
          sortable: false,
          width: '25%',
        },
        {
          text: 'Тип деятельности',
          value: 'achievement_type_name',
          groupable: false,
          sortable: false,
          width: '33%',
          divider: true,
        },
        {
          text: 'Сумма по деятельности',
          value: 'sum_score_selected_activity',
          groupable: false,
          sortable: false,
          width: '10%',
          align: 'center',
        },
        {
          text: 'Общая сумма баллов',
          value: 'sum_score',
          groupable: false,
          sortable: false,
          width: '10%',
          divider: true,
          align: 'center',
        },
        {
          text: `Голосов "за"`,
          value: 'count_votes',
          groupable: false,
          sortable: false,
          width: '10%',
          align: 'center',
        },
        { text: '', width: '8%', value: 'data-table-expand' },
      ],

      expanded: [],
      singleExpand: false,
      page: 1,
      itemsPerPage: 8,
      selectedStatements: [],
    };
  },

  computed: {

    ...mapState({
      dialogVote: state => state.scholarship_vote.dialogVote,
    }),

    ...mapGetters({
      statementsAndVotes: 'scholarship_vote/statementsAndVotes',
      memberVotes: 'scholarship_vote/memberVotes',
    }),

    numberOfPages () {
      return Math.ceil(this.statementsAndVotes.length / this.itemsPerPage)
    },

    PersonNameConverter() {
      return PersonNameConverter;
    },
  },

  watch: {
    "memberVotes": function () {
      if (!_.isEmpty(this.memberVotes)) {
        this.selectedStatements = this.memberVotes;
      }
    },

    "selectedStatements": function () {
      this.setSelectedStatements(this.selectedStatements);
    },
  },

  methods: {

    ...mapMutations({
      setSelectedStatements: 'scholarship_vote/setSelectedStatements',
    }),

    showStudentStatement(id) {
      this.getStatement(id);
      this.$emit("showStudentStatement");
    },

    nameMember(item) {
      if (!_.isNil(item.specEmployee)) {
        return PersonNameConverter.shortName(item.specEmployee);
      }

      if (!_.isNil(item.person)) {
        return PersonNameConverter.shortName(item.person);
      }

      return "";
    },

    shortName(fullName) {
      if (_.isNil(fullName)) return "";
      return PersonNameConverter.shortName(fullName);
    },

  },
}
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="statementsAndVotes"
    hide-default-footer
    show-expand
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    show-select
    v-model="selectedStatements"
    :page="page"
    :items-per-page.sync="itemsPerPage"
    item-key="id"
    key="id"
  >
  <template #no-data>
    Нет заявлений
  </template>

    <template #loading>
      Идет загрузка...
    </template>

    <template #item.Number="{item, index}">
      {{statementsAndVotes.indexOf(item) + 1}}
    </template>

    <template #item.count_votes="{item, index}">
      <v-chip
        color="teal darken-3"
        class="white--text"
      >
        {{item.count_votes}}
        <v-icon right small>fa-thumbs-up</v-icon>
      </v-chip>
    </template>

    <template #item.sum_score_selected_activity="{item, index}">
      <v-chip small>
        <v-icon small left>
          fa-certificate
        </v-icon>
        {{item.sum_score_selected_activity}}
      </v-chip>
    </template>

    <template #item.sum_score="{item, index}">
      <v-chip small>
        <v-icon small left>
          fa-trophy
        </v-icon>
        {{item.sum_score}}
      </v-chip>
    </template>

    <template #item.participant="{item, index}">
      <v-list-item class="px-0">
        <v-list-item-content>
          <v-list-item-title>
            {{shortName(item.person_full_name)}}
          </v-list-item-title>
          <v-list-item-subtitle>
            Группа {{item.group_name}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <v-chip
          v-for="member in item.member_votes"
          :key="member.id"
          color="teal darken-3"
          class="white--text"
        >
          {{nameMember(member)}}
          <v-icon right small>fa-thumbs-up</v-icon>
        </v-chip>
      </td>
    </template>

    <template #footer>
      <v-divider/>
      <v-row
        class="pb-2 mt-2"
        align="center"
        justify="center">
        <v-col cols="12" class="text-center">
          <v-pagination
            circle
            color="teal darken-3"
            v-model="page"
            :length="numberOfPages"
            :total-visible="5">
          </v-pagination>
        </v-col>
      </v-row>
    </template>

  </v-data-table>
</template>

<style scoped>

</style>